import axios from "axios";

const RAW_BASE = import.meta.env.VITE_URL || import.meta.env.VITE_URL2 || "http://localhost:3000";
// Some environments may set VITE_URL as ".../api/activity" already; normalize to host base.
const BASE = String(RAW_BASE).replace(/\/api\/activity\/?$/i, "");
export const ACTIVITY_API_BASE = `${BASE}/api/activity`;

const UNSPLASH_ACTIVITY = "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=800&q=80";
const UNSPLASH_CITY = "https://images.unsplash.com/photo-1518780664697-55e3ad937233?w=800&q=80";
const UNSPLASH_COUNTRY = "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&q=80";
const UNSPLASH_HERO_SLIDES = [
  "https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=1600&q=80",
  "https://images.unsplash.com/photo-1506929562872-bb421503ef21?w=1600&q=80",
  "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=1600&q=80",
];

export function getImageUrl(path, baseUrl) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  const base = baseUrl || BASE;
  return `${base}/${String(path).replace(/\\/g, "/")}`;
}

export function getActivityImageUrl(path, baseUrl) {
  const url = getImageUrl(path, baseUrl);
  return url || UNSPLASH_ACTIVITY;
}

export function getCityImageUrl(path, baseUrl) {
  const url = getImageUrl(path, baseUrl);
  return url || UNSPLASH_CITY;
}

export function getCountryImageUrl(path, baseUrl) {
  const url = getImageUrl(path, baseUrl);
  return url || UNSPLASH_COUNTRY;
}

export const UNSPLASH_HERO = UNSPLASH_HERO_SLIDES;

export async function fetchCountries() {
  const { data } = await axios.get(`${ACTIVITY_API_BASE}/user/countries`);
  return data?.data || [];
}

export async function fetchCities(countryId) {
  const { data } = await axios.get(`${ACTIVITY_API_BASE}/user/cities/${countryId}`);
  return data?.data || [];
}

export async function fetchActivities(cityId) {
  const { data } = await axios.get(`${ACTIVITY_API_BASE}/user/activities/${cityId}`);
  return data?.data || [];
}

/** Fetch single activity by id (for detail page when cityId not in state). */
export async function fetchActivityDetail(activityId) {
  const { data } = await axios.get(`${ACTIVITY_API_BASE}/user/activities/detail/${activityId}`);
  return data?.data || null;
}

export async function fetchActivityOptions(activityId) {
  const { data } = await axios.get(`${ACTIVITY_API_BASE}/user/activity-options/${activityId}`);
  return data?.data || [];
}

export async function fetchTimePricing(activityOptionId) {
  const { data } = await axios.get(`${ACTIVITY_API_BASE}/user/time-pricing/option/${activityOptionId}`);
  return data?.data || [];
}

/** Fetch admin-defined time slots for an option (slot-based booking). */
export async function fetchTimeSlotsByOption(activityOptionId) {
  const id = activityOptionId != null ? String(activityOptionId) : "";
  if (!id) return [];
  const { data } = await axios.get(`${ACTIVITY_API_BASE}/user/time-slots/${id}`);
  return Array.isArray(data?.data) ? data.data : [];
}

export async function fetchVisitorTypes() {
  const { data } = await axios.get(`${ACTIVITY_API_BASE}/user/visitor-types`);
  return data?.data || [];
}

export async function calculatePrice(body) {
  const { data } = await axios.post(`${ACTIVITY_API_BASE}/user/calculate-price`, body);
  return data?.data || null;
}

/** Check slot capacity. Returns { totalBooked, maxCapacity, isFull } or null. */
export async function checkSlotCapacity(activityOptionIdOrParams, selectedDateTime) {
  const params =
    activityOptionIdOrParams && typeof activityOptionIdOrParams === "object"
      ? activityOptionIdOrParams
      : { activityOptionId: activityOptionIdOrParams, selectedDateTime };
  const { data } = await axios.get(`${ACTIVITY_API_BASE}/user/check-capacity`, { params });
  return data?.data || null;
}

export async function createBooking(body) {
  const { data } = await axios.post(`${ACTIVITY_API_BASE}/user/bookings`, body, { withCredentials: true });
  return data;
}

/** Create Razorpay order for activity payment. Returns { success, order } or throws. */
export async function createActivityOrder(amount) {
  const { data } = await axios.post(`${ACTIVITY_API_BASE}/create-order`, { amount: Number(amount) }, { withCredentials: true });
  return data;
}
